// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "c80b78652cdc40b019b35351c6942de3" + ".js";
};